import {assert} from '@appscience/utils'
import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export interface TemperatureData {
  title: string
  id: string
  color: string
}

export const temperaturesAtom = createPrimitiveAtom<
  Record<string, TemperatureData>
>({})

export async function updateTemperaturesAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().listsApi.getTemperatures()
  const record = indexBy(x => x.id, data)
  dispatch(temperaturesAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}

export function getTemperaturesTitle(id: string) {
  return (
    assert(
      temperaturesAtom.getState()[id],
      `TemperaturesAtom error: temperature with id "${id}" not found`,
    )?.title || ''
  )
}

export function assertTemperature(id: string): string | null {
  return (
    assert(
      temperaturesAtom.getState()[id],
      `TemperaturesAtom assertion failed: temperature with id "${id}" not found`,
    )?.id || null
  )
}
